export enum VodSubtitleLanguagesEnum {
  SQ = 'SQ',
  EN = 'EN'
}
